import { Helmet } from 'react-helmet';
import {
    Box,
    Button,
    Card,
    CardHeader,
    CardActions,
    CardContent,
    Chip,
    Container,
    Divider,
    Checkbox,
    Grid,
    Typography,
    Paper,
    TextField,
    Switch,
    FormGroup,
    FormControlLabel,
    MenuItem,
    Select,
    FormHelperText
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import emtyData from "../../../../assets/images/emty-data.png";
import { Formik } from "formik";
import * as Yup from 'yup';
import DialogIcon from "../../../../components/kpi/DialogIcon";
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../../../services/global.service";
import Icon from '@mui/material/Icon';
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import adminService from "../../../../services/admin.service";

const styles = {
    path: {
        color: "#68717A",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    buttonFile: {
        position: "absolute",
        right: "1px",
        top: "1px",
        // bottom: "9px",
        background: "linear-gradient(0deg, #E5E9EC, #E5E9EC), #404349",
        borderLeft: "1px solid #CED4DA",
        "border-radius": "0px 4px 4px 0px",
        width: "100px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
    dropdowm: {
        position: "absolute",
        right: "20px",
        top: "40%",
        // bottom: "9px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
};

const GoalItemEdit = (props) => {
    const { t } = useTranslation();

    useEffect(() => {
    }, []);

    const useStyles = makeStyles({
        iconContainer: {
            '& svg': {
                width: "45px",
                height: "45px"
            }
        },
        formTextField: {
            '& .MuiTextField-root': { m: 1, width: '25ch' },
        },
        input: {
            '& div > input': {
                height: '8px',
                position: "relative"
            }
        },

        inputError: {
            '& div > input': {
                color: "#CC6058",
                background: "#CC60581A",
                textAlign: "center",
                height: '6px',
                border: "1px solid #CC6058 !important",
                borderRadius: "4px"
            }
        },
        disabled: {
            '& div > input': {
                height: '8px',
                position: "relative"
            },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            }
        },
        selectDisabled: {
            // '& .MuiFormControl-root': {
            background: "#FAFAFA",
            borderRadius: "4px",
            // },
            '&.Mui-selected': {
                '-webkit-text-fill-color': '#404349 !important',
                backgroundColor: "#FAFAFA !important"
            },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                backgroundColor: "#FAFAFA !important"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            },
            '& div ': {
                padding: "8.5px 14px"
            }
        },
        select: {
            '& div ': {
                padding: "8.5px 14px"
            }
        },
    })
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    let { serial, groupID, page } = useParams()
    const classes = useStyles();
    const [status, setStatus] = React.useState(true);
    const [edit, setEdit] = React.useState(false);
    const [openIcon, setOpenIcon] = React.useState(false);
    const [defaults, setDefault] = React.useState(false);
    const [backgroundColorValue, setBackgroundColorValue] = React.useState("#5DA196");
    const [backgroundColorStatus, setBackgroundColorStatus] = React.useState(false);
    const [competencyFormSelectValue, setCompetencyFormValue] = React.useState("");
    const [competencyFormSelect, setCompetencyForm] = React.useState([]);
    const [errorText, seterrorText] = React.useState("");
    const [titleGoalGroup, setTitleGoalGroup] = React.useState("");
    const [titleGoalSubgroup, setTitleGoalSubgroup] = React.useState("");
    const [titleGoalLibrary, setTitleGoalLibrary] = React.useState("");
    const [idGoalGroup, setIdGoalGroup] = React.useState("");
    const [idGoalSubgroup, setIdGoalSubgroup] = React.useState("");
    const [idGoalLibrary, setIdGoalLibrary] = React.useState("");
    const [goal_subgroup_id, setGoal_subgroup_id] = React.useState("");
    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const [allow_adjust, setAllowAdjust] = React.useState(false);
    const [isUsed, setIsUsed] = React.useState(false);

    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const handleStatus = () => {
        setStatus(!status)
    }
    const [formData, setFormData] = React.useState({
        code: '',
        nameEN: '',
        nameTH: '',
    });

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: "50px !important",
        height: "24px !important",
        padding: "0 !important",
        marginRight: "10px",
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: "4px 6px",
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(22px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#5DA196',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 1,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 1,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 16,
            height: 16,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#C0C0C0' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
        "& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track": {
            backgroundColor: "#D8D8D8!important"
        }
    }));

    const validationSchema = yup.object({
        code: yup.string().required(t('admin.inputForm.msgError.code')),
        nameEN: yup.string().max(255, " ").required(t('admin.inputForm.msgError.nameTH')),
        descriptionEN: yup.string().max(255, " ").required(t('admin.inputForm.msgError.nameTH')),
        goalMetric: yup.string().required(t('admin.inputForm.msgError.plessSelect')),
        nameTH: defaults === true ? yup.string().max(255, " ").required(t('admin.inputForm.msgError.nameTH')) : yup.string().max(255, " "),
        descriptionTH: defaults === true ? yup.string().max(255, " ").required(t('admin.inputForm.msgError.nameTH')) : yup.string().max(255, " "),
    });
    const formik = useFormik({
        initialValues: {
            code: "",
            nameEN: "",
            descriptionEN: "",
            nameTH: "",
            descriptionTH: "",
            goalMetric: "",
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            submit(values)
            // openSuccessAddDialog(true)
        },
    });
    const handleChangeWorkloadForm = (event) => {
        setCompetencyFormValue(event.target.value);
    };
    const handleSubmit = () => {
        formik.submitForm()
    }
    const handleCancel = () => {
        setDiscardDialog(true)
    }
    const onCheckDefault = () => {
        setDefault(!defaults)
    }
    const [discardDialog, setDiscardDialog] = React.useState(false);
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        handleDiscardDialog(false)
        if (page === "1") {
            navigate('/admin/goal-group/' + idGoalLibrary, { replace: false });
        } else if (page === "2") {
            navigate('/admin/goal-sub-group/' + idGoalGroup, { replace: false });
        } else if (page === "3") {
            navigate('/admin/goal-item/2/' + idGoalSubgroup, { replace: false });
        }
    };
    const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
    const handleDirect = () => {
        openSuccessAddDialog(false)
        if (page === "1") {
            navigate('/admin/goal-item/1/' + idGoalGroup, { replace: false });
        } else if (page === "2") {
        } else if (page === "3") {
            navigate('/admin/goal-item/2/' + idGoalSubgroup, { replace: false });
        }
    }
    const submit = (data) => {
        adminService.editGoalLibraryGoalItem({
            code: data.code,
            name_en: data?.nameEN,
            name_th: data?.nameTH,
            description_en: data?.descriptionEN,
            description_th: data?.descriptionTH,
            options: {
                goal_metric: data?.goalMetric
            },
            status: status === true ? "active" : "inactive",
        }, serial).then(
            (response) => {
                openSuccessAddDialog(true)
            },
        ).catch(() => {
            handleOpenFailedMessageDialog()
        })
    }
    const formikChange = (val, field) => {
        formik.setFieldValue(field, val.target.value)
    }
    useEffect(() => {
        if (page === "1") {
            adminService.detailGoalGroup(groupID).then((rs) => {
                let data_goal_group = rs?.data?.goal_group
                let data_goal_library = rs?.data?.goal_library
                setTitleGoalGroup(data_goal_group?.name)
                setTitleGoalLibrary(data_goal_library?.name)
                setIdGoalGroup(data_goal_group?.serial)
                setIdGoalLibrary(data_goal_library?.serial)
                setGoal_subgroup_id(data_goal_group?.serial)
                // setTitle(data?.name)
            })
                .catch((err) => {

                })
        } else if (page === "2" || page === "3") {
            adminService.detailGoalSubGroup(groupID).then((rs) => {
                let data_goal_group = rs?.data?.goal_group
                let data_goal_library = rs?.data?.goal_library
                let data_goal_subgroup = rs?.data?.goal_subgroup
                setTitleGoalGroup(data_goal_group?.name)
                setTitleGoalSubgroup(data_goal_subgroup?.name)
                setTitleGoalLibrary(data_goal_library?.name)
                setIdGoalGroup(data_goal_group?.serial)
                setIdGoalSubgroup(data_goal_subgroup?.serial)
                setIdGoalLibrary(data_goal_library?.serial)
                setGoal_subgroup_id(data_goal_subgroup?.serial)
                // setTitle(data?.name)
            })
                .catch((err) => {

                })
        } else {
            // navigate('/admin/goal-library-master', { replace: false });
        }
        adminService.detailGoalLibraryGoalItem(serial).then((rs) => {
            let data = rs?.data?.goal_library
            let dataDetail = rs?.data?.goal_item
            formik.setFieldValue("nameEN", dataDetail?.options?.name_en !== undefined ? dataDetail?.options?.name_en : dataDetail?.name)
            formik.setFieldValue("nameTH", dataDetail?.options?.name_th !== undefined ? dataDetail?.options?.name_th : "")
            formik.setFieldValue("descriptionEN", dataDetail?.options?.description_en !== undefined ? dataDetail?.options?.description_en : dataDetail?.description)
            formik.setFieldValue("descriptionTH", dataDetail?.options?.description_th !== undefined ? dataDetail?.options?.description_th : "")
            formik.setFieldValue("code", dataDetail?.code)
            formik.setFieldValue("goalMetric", dataDetail?.goal_metric?.serial)
            if (dataDetail?.options?.name_th !== undefined && dataDetail?.options?.description_th) {
                setDefault(true)
            }
            setStatus(dataDetail.status === "active" ? true : false)
            setAllowAdjust(data?.allow_adjust)
            // setTitle(data?.name)
            setEdit(false)
            setIsUsed(dataDetail?.is_used ?? false)
        })
            .catch((err) => {

            })
        adminService.listGoalMetric().then((rs) => {
            setCompetencyForm(rs?.data?.metric !== undefined ? rs?.data?.metric : [])
            // setTitle(data?.name)
        })
            .catch((err) => {

            })
    }, []);
    return (
        <>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        {
                            page === "1" ?
                                <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/admin/goal-library-master')}>{t('admin.label.goalLibraryMaster')}</span> / <span style={styles.link} onClick={() => clickLink('/admin/goal-group/' + idGoalLibrary)}>{titleGoalLibrary}</span> / <span style={styles.end} >{serial !== undefined ? t('admin.label.editGoal') : t('admin.label.createGoal')}</span></Typography>
                                :
                                page === "2" ?
                                    <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/admin/goal-library-master')}>{t('admin.label.goalLibraryMaster')}</span> / <span style={styles.link} onClick={() => clickLink('/admin/goal-group/' + idGoalLibrary)}>{titleGoalLibrary}</span> / <span style={styles.link} onClick={() => clickLink('/admin/goal-sub-group/' + idGoalGroup)}>{titleGoalGroup}</span> / <span style={styles.end} >{serial !== undefined ? t('admin.label.editGoal') : t('admin.label.createGoal')}</span></Typography>
                                    :
                                    page === "3" ?
                                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/admin/goal-library-master')}>{t('admin.label.goalLibraryMaster')}</span> / <span style={styles.link} onClick={() => clickLink('/admin/goal-group/' + idGoalLibrary)}>{titleGoalLibrary}</span> / <span style={styles.link} onClick={() => clickLink('/admin/goal-sub-group/' + idGoalGroup)}>{titleGoalGroup}</span> / <span style={styles.link} onClick={() => clickLink('/admin/goal-item/2/' + idGoalSubgroup)}>{titleGoalSubgroup}</span> / <span style={styles.end} >{serial !== undefined ? t('admin.label.editGoal') : t('admin.label.createGoal')}</span></Typography>
                                        :
                                        null
                        }
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} >
                            <Typography variant="h1" fontSize={36} lineHeight="53.82px" fontWeight="500" color="#404349">
                                {serial !== undefined ? t('admin.label.editGoal') : t('admin.label.createGoal')}
                            </Typography>
                        </Grid>
                        <Grid direction="column" sx={{}}
                            container item
                            justifyContent="center"
                            alignItems="center">

                            <Grid container item>
                                <Paper elevation={6} sx={{ 'border-radius': '20px', width: '100%', ".MuiFormHelperText-root": { position: "absolute", bottom: "-23px" } }} classes={{ root: classes.error }}>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "50px 0px 20px 25px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": "#FAFAFA", "-webkit-text-fill-color": "#000 !important" }, "fieldset": { "border-color": "#FFFFFF !important" } }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.label.goalGroup')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                // error={Boolean(formik.touched.code && formik.errors.code)}
                                                fullWidth
                                                // helperText={formik.touched.code && formik.errors.code}
                                                margin="normal"
                                                name="goalGroup"
                                                disabled
                                                type="text"
                                                value={titleGoalGroup}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                classes={{ root: classes.input }}
                                            />
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": "#FAFAFA", "-webkit-text-fill-color": "#000 !important" }, "fieldset": { "border-color": "#FFFFFF !important" } }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.label.goalSubGroup')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                // error={Boolean(formik.touched.code && formik.errors.code)}
                                                fullWidth
                                                // helperText={formik.touched.code && formik.errors.code}
                                                margin="normal"
                                                name="goalSubGroup"
                                                disabled
                                                type="text"
                                                value={titleGoalSubgroup}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                classes={{ root: classes.input }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 20px 25px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.code')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.code && formik.errors.code)}
                                                fullWidth
                                                helperText={formik.touched.code && formik.errors.code}
                                                margin="normal"
                                                name="code"
                                                disabled
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.code}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.code')}
                                                classes={{ root: classes.input }}
                                            />
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.status')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <Box sx={{ paddingTop: "16px", height: "100%", "max-height": "55px", display: "flex", "align-items": "center" }}>
                                                <FormGroup >
                                                    <FormControlLabel
                                                        sx={{ m: 0 }}
                                                        control={<IOSSwitch checked={status} disabled={edit === false ? allow_adjust === true ? false : true : isUsed === true ? true : false} onChange={() => handleStatus()} />}
                                                        label={status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')}
                                                    // disabled
                                                    />
                                                </FormGroup>
                                                {/* <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography> */}
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 20px 25px" }}>
                                        <Grid item lg md xs={12} sx={{ paddingTop: "0 !important" }}>
                                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                                                <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.nameEN')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                                <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik.values.nameEN, "").length === 0 ? "#D8D8D8" : Util.formatData(formik.values.nameEN, "").length <= 255 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik.values.nameEN, "").length}/255</Typography>
                                            </Box>
                                            <TextField
                                                error={Boolean(formik.touched.nameEN && formik.errors.nameEN)}
                                                fullWidth
                                                helperText={formik.touched.nameEN && formik.errors.nameEN}
                                                margin="normal"
                                                name="nameEN"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.nameEN}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.nameEN')}
                                                classes={{ root: allow_adjust === true ? classes.input : classes.disabled }}
                                                disabled={allow_adjust === true ? false : true}
                                            />
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 20px 25px" }}>
                                        <Grid item lg md xs={12} sx={{ paddingTop: "0 !important" }}>
                                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                                                <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.descriptionEN')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                                <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik.values.descriptionEN, "").length === 0 ? "#D8D8D8" : Util.formatData(formik.values.descriptionEN, "").length <= 255 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik.values.descriptionEN, "").length}/255</Typography>
                                            </Box>
                                            <TextField
                                                error={Boolean(formik.touched.descriptionEN && formik.errors.descriptionEN)}
                                                fullWidth
                                                helperText={formik.touched.descriptionEN && formik.errors.descriptionEN}
                                                margin="normal"
                                                name="descriptionEN"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.descriptionEN}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.descriptionEN')}
                                                classes={{ root: allow_adjust === true ? classes.input : classes.disabled }}
                                                disabled={allow_adjust === true ? false : true}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 20px 25px" }}>
                                        <Grid item lg md xs={12} sx={{ display: "flex", "align-items": "center", paddingTop: "0 !important", ".MuiSvgIcon-root": { width: "27px", height: "27px", "margin-left": "-3.75px" }, ".MuiCheckbox-root": { padding: "0" } }}>
                                            <Checkbox onChange={e => onCheckDefault()} checked={defaults} disabled={allow_adjust === true ? false : true} />
                                            <Typography pl="15px" color="#404349" fontSize={16} lineHeight="24px" >{t('admin.label.addThaiNameDescription')}</Typography>
                                        </Grid>
                                    </Grid>
                                    {defaults === true ?
                                        <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 20px 25px" }}>
                                            <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                                                    <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.nameTH')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                                    <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik.values.nameTH, "").length === 0 ? "#D8D8D8" : Util.formatData(formik.values.nameTH, "").length <= 255 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik.values.nameTH, "").length}/255</Typography>
                                                </Box>
                                                <TextField
                                                    error={Boolean(formik.touched.nameTH && formik.errors.nameTH)}
                                                    fullWidth
                                                    helperText={formik.touched.nameTH && formik.errors.nameTH}
                                                    margin="normal"
                                                    name="nameTH"
                                                    onBlur={formik.handleBlur}
                                                    onChange={formik.handleChange}
                                                    type="text"
                                                    value={formik.values.nameTH}
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    placeholder={t('admin.inputForm.placeholder.nameTH')}
                                                    classes={{ root: allow_adjust === true ? classes.input : classes.disabled }}
                                                    disabled={allow_adjust === true ? false : true}
                                                />
                                            </Grid>
                                            <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            </Grid>
                                        </Grid>
                                        : null
                                    }
                                    {defaults === true ?
                                        <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 20px 25px" }}>
                                            <Grid item lg md xs={12} sx={{ paddingTop: "0 !important" }}>
                                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                                                    <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.descriptionTH')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                                    <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik.values.descriptionTH, "").length === 0 ? "#D8D8D8" : Util.formatData(formik.values.descriptionTH, "").length <= 255 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik.values.descriptionTH, "").length}/255</Typography>
                                                </Box>
                                                <TextField
                                                    error={Boolean(formik.touched.descriptionTH && formik.errors.descriptionTH)}
                                                    fullWidth
                                                    helperText={formik.touched.descriptionTH && formik.errors.descriptionTH}
                                                    margin="normal"
                                                    name="descriptionTH"
                                                    onBlur={formik.handleBlur}
                                                    onChange={formik.handleChange}
                                                    type="text"
                                                    value={formik.values.descriptionTH}
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    placeholder={t('admin.inputForm.placeholder.descriptionTH')}
                                                    classes={{ root: allow_adjust === true ? classes.input : classes.disabled }}
                                                    disabled={allow_adjust === true ? false : true}
                                                />
                                            </Grid>
                                        </Grid>
                                        : null
                                    }
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 20px 25px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", position: "relative", }}>
                                            <Typography variant="subtitle1" fontSize={18} pb="16px" lineHeight="24px" display="flex">{t('admin.label.goalMetric')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <Select
                                                id="workload-select"
                                                inputlabelprops={{ shrink: false }}
                                                variant="outlined"
                                                size="small"
                                                className="white-bg"
                                                value={formik.values.goalMetric}
                                                onChange={e => formikChange(e, "goalMetric")}
                                                defaultValue=""
                                                displayEmpty
                                                placeholder={t('admin.inputForm.placeholder.goalMetric')}
                                                error={Boolean(formik.touched.goalMetric && formik.errors.goalMetric)}
                                                fullWidth
                                                helperText={formik.touched.goalMetric && formik.errors.goalMetric}
                                                name="goalMetric"
                                                sx={Boolean(formik.touched.goalMetric && formik.errors.goalMetric) ? { border: "0.5px solid red", marginBottom: 0 } : { marginBottom: 0 }}
                                                disabled={allow_adjust === true ? false : true}
                                                classes={{ root: allow_adjust === true ? classes.select : classes.selectDisabled }}
                                            >
                                                <MenuItem disabled value="">
                                                    <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.goalMetric')}</Typography>
                                                </MenuItem>
                                                {
                                                    competencyFormSelect?.length > 0 ?
                                                        competencyFormSelect.map(item => {
                                                            return (
                                                                <MenuItem value={item.serial} key={item.serial}>
                                                                    {item.code}
                                                                </MenuItem>
                                                            )
                                                        })

                                                        : <MenuItem value="">
                                                            ---{t('label.notFund')}---
                                                        </MenuItem>
                                                }
                                            </Select>
                                            {formik.touched.goalMetric && formik.errors.goalMetric ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.goalMetric} </FormHelperText>) : <></>}
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                        </Grid>
                                    </Grid>
                                    <Grid container mt={3} mb={3} pr={4} >
                                        <Grid item xs display="flex" flexDirection="row-reverse">
                                            <Box sx={{ width: "100px" }}>
                                                <Button onClick={handleSubmit} color="primary" variant="contained" fullWidth>
                                                    {t('label.save')}
                                                </Button>
                                            </Box>
                                            <Box mr={2} sx={{ width: "100px" }}>
                                                <Button color="black" variant="outlined" fullWidth onClick={handleCancel}>
                                                    {t('label.cancel')}
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>

                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <SimpleDialog
                        open={isSuccessAddDialogOpen}
                        doDirect={() => handleDirect()}
                        setValue={openSuccessAddDialog}
                        text={t('admin.label.GoalItemEditSuccessfully')}
                        page={true}
                    />
                    <MessageDialog
                        open={openFailedMessageDialog}
                        setValue={handleCloseFailedMessageDialog}
                        type="fail"
                        title={t(`dialog.label.fail`)}
                        text={t(`admin.label.GoalItemEditFail`)}
                    />
                    <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t('label.confirmationOfDiscard')} text={t('label.youSureDiscardChange')} />
                </Container>
            </Box>
        </>
    )
};
export default GoalItemEdit;
